import { baseTemplateParams } from '../shared/baseParams.js'
import { EDITORIAL_EVENT_DEFAULTS } from '../shared/editorialEventDefaults.js'

export const defaultTemplateParams = {
  ...baseTemplateParams,
  ...EDITORIAL_EVENT_DEFAULTS,
  richtextFields: {
    ...baseTemplateParams.richtextFields,
    ...EDITORIAL_EVENT_DEFAULTS.richtextFields
  },
  selectedTemplate: 'editorialEvent',
  shellTemplateKey: 'editorialEvent'
}

export default defaultTemplateParams
